<template>
  <!-- 我的申报记录页面 -->
  <div class="applyRecord">
<!--    <div class="top-banner-box">-->
<!--      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">-->
<!--&lt;!&ndash;        <div class="banner-btn" @click="tianbao">上云填报</div>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--    <el-button type="primary" @click="addNew" style="float: right;margin-bottom: 25px" :disabled="dataList.length >0">服务商申报</el-button>-->
    <serviceTable
      :headList="headList"
      :dataList="dataList"
      :buttonList="buttonList"
      @check="check"
      @submit="submit"
      :background="true"
      @currentChange="currentChange"
      :total="total"
      :currentPage="currentPage"
      :btnWidth="120"
    />
  </div>
</template>

<script>
import {getServiceProviderRecord, getProList, sumbitServiceProviderAllInfo} from "../../utils/interface";
import serviceTable from "./commonTable.vue";
// import commonTable from "../../components/commonTable.vue";
export default {
  name: "serviceApplyRecord",
  components: { serviceTable },
  props: {},
  data() {
    return {
      headerBgUrl: require("@/assets/publicService/service_bg.jpg"),
      form: {
        year: "", // 项目政策年份
        policyUuid: "", // 政策id
        projectName: "", // 项目名称
        createDate: "", // 申报时间
        auditDate: "", // 审核时间
        status: "" // 审核状态
      },
      policyList: [], // 政策
      typeList: [
        { label: "全部", value: "" },
        { label: "待提交", value: "1" },
        { label: "审核中", value: "2" },
        { label: "审核通过", value: "3" },
        { label: "审核不通过", value: "4" }
      ], // 审核状态
      headList: [
        // { label: "项目政策", value: "policyName", width: 400 },
        // { label: "项目名称", value: "projectName" },
        // { label: "申报时间", value: "createDate" },
        // { label: "审核状态", value: "status", type: "verify" },
        // { label: "审核时间", value: "auditDate" }
        { label: "企业名称", value: "unitName", width: 400 },
        { label: "申报时间", value: "applyTime" },
        { label: "状态", value: "status", type: "verify" }
      ],

      dataList: [],
      buttonList: [
        { name: "查看", type: "applyCheck" },
        { name: "继续提报", type: "applyEdit" },
        { name: "提交", type: "applySubmit" },
      ],
      total: 0,
      currentPage: 1
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getProList();
    this.query();
  },
  methods: {
    addNew() {
      let router = this.$router.resolve({
        path: "./serviceProviderApply",
        query: {
          status: "1"
        }
      });
      window.open(router.href, "_blank");
    },
    /* 查询申请记录 */
    query(refresh) {
      getServiceProviderRecord({
        current: this.currentPage,
        pageSize: "10",
        userUuid: this.$store.state.isUsermessage.uuid,
        ...this.form
      }).then(res => {
        if (res && res.list.length > 0) {
         this.dataList = res.list;
          //this.dataList = [{type:1},{type:1},{type:1}]
          console.log("服务商申报记录in---",res,res.list,this.dataList)
          this.total = res.total;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    /* 查看详情 */
    check(item) {
      // console.log(item)
      let router = this.$router.resolve({
        path: "./serviceProviderApply",
        query: {
          uuid: item.uuid,
          status: item.status,
        }
      });
      window.open(router.href, "_blank");
    },
    /* 提交 */
    submit(item) {
        sumbitServiceProviderAllInfo({uuid:item.uuid}).then(res => {
          console.log("提交服务商申报记录new",res);
          if (res.success) {
            // this.$message({
            //   message: res.message,
            //   type: "success"
            // });
            // this.query();
            let routeData = this.$router.resolve({
              name: "serviceProviderList",
            });
            window.open(routeData.href, "_target");
            // this.$confirm("提交成功!", "提示", {
            //   confirmButtonText: "确认",
            //   showCancelButton: false,
            //   type: "success"
            // }).then(() => {
            //   let routeData = this.$router.resolve({
            //     name: "serviceProviderList",
            //   });
            //   window.open(routeData.href, "_target");
            // });
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        });
    },
    /* 获取政策 */
    getProList() {
      getProList({ state: "1" }).then(res => {
        if (res && res.length > 0) {
          this.policyList = res;
        } else {
          this.policyList = [];
        }
      });
    },
    queryProList() {},
    currentChange(Page) {
      this.currentPage = Page.currentPage;
      this.query();
    },
    reset() {
      this.form = {
        year: "", // 项目政策年份
        policyUuid: "", // 政策id
        projectName: "", // 项目名称
        createDate: "", // 申报时间
        auditDate: "", // 审核时间
        status: "" // 审核状态
      };
      this.query();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.applyRecord {
  /deep/ .el-row {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    padding-right: 15px;
  }

  /deep/ .el-form-item__content {
    margin-right: 20px;
  }

  .mr0 {
    /deep/ .el-form-item__content {
      margin-right: 0;
    }
  }
  .top-banner-box {
    // background-color: #f7f8fb;

    .top-banner-img {
      height: 300px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .banner-btn {
        position: absolute;
        cursor: pointer;
        bottom: 78px;
        font-size: 16px;
        width: 112px;
        height: 38px;
        .lh(38px);
        text-align: center;
        background-color: #f6c506;
        border-radius: 19px;
        letter-spacing: 1.5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/providerApply/applyRecord.vue